exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._9GQ9sDaLT8xf23R5iVslqA\\=\\={display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gieTHA9TAeGHxmnks\\+VnIA\\=\\={width:24px;height:24px;fill:currentColor}", ""]);
// Exports
exports.locals = {
	"root": "_9GQ9sDaLT8xf23R5iVslqA==",
	"svg": "gieTHA9TAeGHxmnks+VnIA=="
};